import React from "react";
import { Link } from "react-router-dom";
import Moment from "moment";
import {
  Row,
  Container,
  Button,
  Modal,
  Spinner,
  Form,
  Col,
} from "react-bootstrap";
import { v1 as uuid } from "uuid";
import { Field, reduxForm, formValueSelector } from "redux-form";
import { connect } from "react-redux";
import _ from "lodash";
import DateRangePickerField from "../../elements/redux-form-elements/DateRangePickerAvailability";
import { withGoogleReCaptcha } from "react-google-recaptcha-v3";
//import { subscribe } from "../../actions/subscirbe";

class AvailabilitySearchForm extends React.Component {
  state = {
    token: null,
    messageFlag: false,
    totPrice: null,
    basePerAdultPrice: null,
    perAdultPrice: null,
  };

  async componentDidMount() {
    let price = this.props.currentpackage.field_vc_adult_price_aud_
      .replace("$", "")
      .replace(",", "")
      .trim();

    this.setState({
      basePerAdultPrice: price,
      perAdultPrice: price,
    });
  }

  componentDidUpdate(previousProps, previousState) {
    let flag = !_.isEqual(previousProps.travelDates, this.props.travelDates);
    if (this.props.travelDates && flag) {
      const totAdults = this.props.formValues.totalAdults;
      const startDate = Moment(this.props.travelDates.startDate);

      let dateInfo = _.find(this.props.allowedDates, [
        "date",
        startDate.format("YYYY-MM-DD"),
      ]);

      let priceAddList =
        this.props.currentpackage.field_price_add_on &&
        this.props.currentpackage.field_price_add_on.split("_");

      let priceAddon =
        priceAddList && parseInt(priceAddList[dateInfo.dateRange]);
      let price = parseInt(this.state.basePerAdultPrice / 100);
      const totPrice = priceAddon + price;
      //console.log(totPrice, price, priceAddon);
      this.setState({ perAdultPrice: totPrice * 100 });

      // let flag = !_.includes(datesList, Moment(day).format("YYYY-MM-DD"));
      // if (flag) {
      //   counter++;
      // }
    }
  }

  renderError({ error, touched }) {
    if (touched && error) {
      return (
        <div className="invalid-feedback d-block">
          <div className="header">
            <strong>{error}</strong>
          </div>
        </div>
      );
    }

    return (
      <div className="d-block">
        <div className="header">&nbsp;</div>
      </div>
    );
  }

  renderInput = ({ placeholder, input, label, meta, type, disabled }) => {
    return (
      <div className="form-group m-0">
        {label && (
          <label className="form-label text-uppercase small">{label}</label>
        )}
        <input
          {...input}
          className="form-control"
          type={type}
          placeholder={placeholder}
          disabled={disabled}
        />
        {this.renderError(meta)}
      </div>
    );
  };

  renderTextArea = ({ placeholder, input, label, meta, type }) => {
    return (
      <div className="form-group">
        <label className="form-label text-uppercase small">{label}</label>
        <textarea
          {...input}
          className="form-control"
          placeholder={placeholder}
          rows="4"
        />
        {this.renderError(meta)}
      </div>
    );
  };

  renderCheckBox = ({ placeholder, input, label, meta, type }) => {
    return (
      <div>
        <div className="form-check form-check-inline">
          <input {...input} className="form-check-input" type={type} />
          <label
            title=""
            htmlFor="inline-checkbox-1"
            className="form-check-label"
          >
            {label}
          </label>
        </div>
      </div>
    );
  };

  renderSelect = ({
    placeholder,
    asyncValidating,
    input,
    label,
    meta,
    children,
  }) => {
    const className = `form-group text-uppercase small`;

    // console.log(input.value);
    // this.setState({ totPrice: input.value * this.state.perAdultPrice });

    return (
      <div className={className}>
        {label && <label>{label}</label>}
        <select {...input} className="form-control">
          {children}
        </select>
      </div>
    );
  };

  renderRadio = ({
    placeholder,
    asyncValidating,
    input,
    label,
    meta,
    children,
  }) => {
    const className = `form-group col-md-4`;
    const values = children;
    return (
      <>
        <label className="form-label text-uppercase small">{label}</label>
        <div className="mb-3">
          {values.map((value, num) => (
            <div className="small form-check form-check-inline" key={num + 1}>
              <input
                {...input}
                type="radio"
                name="preferredContact"
                id={`inline-radio-${num + 1}`}
                className="form-check-input"
                value={value.props.label}
              />
              <label
                title=""
                htmlFor={`inline-radio-${num + 1}`}
                className="form-check-label"
              >
                {value.props.label}
              </label>
            </div>
          ))}
          {this.renderError(meta)}
        </div>
      </>
    );
  };

  onSubmit = (formValues) => {
    formValues = {
      ...formValues,
      totalPrice: (formValues.noAdult * this.state.perAdultPrice) / 100,
    };
    this.props.availabilityForm(formValues);
  };

  render() {
    const {
      handleSubmit,
      formValues,
      currentpackage,
      fromDates,
      toDates,
      allowedDates,
    } = this.props;

    const tvlDates = _.map(allowedDates, "date");

    return (
      <form onSubmit={handleSubmit(this.onSubmit)}>
        <Field
          name="travelDates"
          component={DateRangePickerField}
          label="Travel Dates"
          totalNights={currentpackage.field_vc_total_nights}
          travelFrom={fromDates}
          travelTo={toDates}
          allowedDates={tvlDates}
        />

        <Field
          name="noAdult"
          component={this.renderSelect}
          label="Number of Adults"
        >
          <option value={currentpackage.field_vc_total_adults}>
            {currentpackage.field_vc_total_adults}
          </option>
          ;
          {/* {[
            ...Array(parseInt(currentpackage.field_vc_total_adults)).keys(),
          ].map((i) => {
            return <option value={i + 1}>{i + 1}</option>;
          })} */}
        </Field>

        {formValues.totalAdults && (
          <div className="text-center">
            <ul className="total-price list-unstyled card-list mt-0 font-weight-bold">
              <li>Total Price:&nbsp;</li>
              <li className="text-viva-red">
                ${(formValues.totalAdults * this.state.perAdultPrice) / 100}{" "}
              </li>
            </ul>
          </div>
        )}

        <button
          disabled={this.state.bookingDisabled}
          className={"btn-book w-100 text-uppercase"}
        >
          Book Now
        </button>
      </form>
    );
  }
}

const validate = (formValues, props) => {
  const errors = {};

  //console.log(formValues);

  let start = formValues.travelDates && formValues.travelDates.startDate;
  let end = formValues.travelDates && formValues.travelDates.endDate;

  if (start && end) {
    start = Moment(formValues.travelDates.startDate, "YYYY-MM-DD");
    end = Moment(formValues.travelDates.endDate, "YYYY-MM-DD").add(1, "days");

    let dates = [];
    let current = start.clone();
    let result = [];

    while (current.isBefore(end)) {
      if (Moment(current.format("YYYY-MM-DD")).isAfter()) {
        result.push(current.format("YYYY-MM-DD"));
      }
      current.add(1, "day");
    }

    dates = [...dates, ...result];

    let counter = 0;

    _.map(dates, (day, id) => {
      let datesList = _.map(props.allowedDates, "date");

      let flag = !_.includes(datesList, Moment(day).format("YYYY-MM-DD"));
      if (flag) {
        counter++;
      }
    });

    if (counter > 0) {
      errors.travelDates = "Date selected includes unavailable dates";
    }
  } else {
    errors.travelDates = "Please select your travel dates";
  }

  // if (!formValues.travelDates) {

  // }

  return errors;
};

const mapStateToProps = (state, ownProps) => {
  const selector = formValueSelector("availabilityForm");
  const enqTypeValue = selector(state, "noAdult");
  const formValues = { totalAdults: enqTypeValue };

  return {
    formValues,
    travelDates: selector(state, "travelDates"),
    initialValues: {
      noAdult: ownProps.currentpackage.field_vc_total_adults,
      noChild: 0,
    },
  };
};

export default connect(mapStateToProps)(
  reduxForm({
    form: "availabilityForm",
    // initialValues: {
    //   email: "",
    //   subject: {props.title}
    // },
    validate,
    enableReinitialize: true,
    destroyOnUnmount: false,
    touchOnChange: true,
  })(AvailabilitySearchForm)
);
